export default __webpack_public_path__ + "static/media/LA17.8f9d9dc3.pdf";